<script setup lang="ts">
defineOptions({
  name: 'DatenschutzPage'
})
</script>

<template>
  <div>
    <Head>
      <Title>Datenschutz</Title>
      <Meta
        name="description"
        content="Datenschutzerklärung von johnsenpartner. architekten – Informationen zur Verarbeitung personenbezogener Daten."
      />
    </Head>
    <Datenschutz />
  </div>
</template>
